export default __webpack_public_path__ + "static/media/gl_4.383d6033.mp3";